import React, { useState, useEffect } from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import { useLocation, Link } from 'react-router-dom';
import * as actions from "store/actions/AuthActions";

const NavBreadcrumb = () => {

    const location = useLocation();
    console.log({ location });
    const params = location.pathname.split("/").filter((item) => item !== "");
    const param1 = params.length > 0 ? params[0] : "";
    const param2 = params.length > 1 ? params[1] : "";
    const param3 = params.length > 2 ? params[2] : "";
    
    const [entityData, setEntityData] = useState(null);
    const [, setLoading] = useState(false);

    // Function to get entity display name
    const getEntityDisplayName = () => {
        if (!entityData) return param2.charAt(0).toUpperCase() + param2.slice(1);
        
        if (param1 === 'quotes' && param2 === 'edit') {
            const number = entityData.qt_number || '';
            const title = entityData.title || '';
            return title ? `${number} - ${title}` : number;
        }
        
        if (param1 === 'invoices' && param2 === 'edit') {
            const number = entityData.inv_number || '';
            return number;
        }
        
        return param2.charAt(0).toUpperCase() + param2.slice(1);
    };

    // Load entity data for edit pages
    useEffect(() => {
        const loadEntityData = async () => {
            if (param2 === 'edit' && param3) {
                setLoading(true);
                try {
                    let response = null;
                    if (param1 === 'quotes') {
                        response = await actions.loadQuote(param3);
                    } else if (param1 === 'invoices') {
                        response = await actions.loadInvoice(param3);
                    }
                    if (response) {
                        setEntityData(response);
                    }
                } catch (error) {
                    console.error('Error loading entity data:', error);
                } finally {
                    setLoading(false);
                }
            } else {
                setEntityData(null);
            }
        };

        loadEntityData();
    }, [param1, param2, param3]);

    return (
        <div style={{ paddingLeft: "40px" }} >
            {!param1 &&
                <Breadcrumb separator=">">
                    <Breadcrumb.Item active><span style={{ marginRight: "5px" }}><HomeOutlined /></span>Home</Breadcrumb.Item>
                </Breadcrumb>
            }
            {
                param1 && !param2 &&
                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="#"><Link to="/"><span style={{ marginRight: "5px" }}><HomeOutlined /></span>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item
                        href="#"
                    >
                        <Link to={`/${param1}`}>
                            {param1.charAt(0).toUpperCase() + param1.slice(1)}
                        </Link>
                    </Breadcrumb.Item>
                    {/* <Breadcrumb.Item
                        active
                    >
                        Dashboard
                    </Breadcrumb.Item> */}
                </Breadcrumb>
            }
            {
                param2 &&
                <Breadcrumb separator=">">
                    <Breadcrumb.Item href="/"><span style={{ marginRight: "5px" }}><HomeOutlined /></span>Home</Breadcrumb.Item>
                    <Breadcrumb.Item
                        href="#"
                    >
                        <Link to={`/${param1}`}>
                            {param1.charAt(0).toUpperCase() + param1.slice(1)}
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item
                        active
                    >
                        {getEntityDisplayName()}
                    </Breadcrumb.Item>
                </Breadcrumb>
            }
        </div>
    )

};
export default NavBreadcrumb;